import { Task } from '@spike/task-model';
import { Option, PetType } from '@spike/model';
import MasterData from '@spike/masterdata-model';
import { PetListItem } from '@spike/appointments-list-model';

export const taskToPetListItem = (task: Task, masterData: MasterData): PetListItem => {
    const petType: PetType = masterData.petTypes.find(pt => pt.id === task.petType) ?? {
        id: 'dogs',
        singular: 'Dog',
        plural: 'Dogs'
    };

    let breedsForType: Option<number>[] = [];
    if (task.petType === 'dogs') breedsForType = masterData.breeds.dogs;
    if (task.petType === 'cats') breedsForType = masterData.breeds.cats;
    if (task.petType === 'exotics') breedsForType = masterData.breeds.exotics;

    const breed: Option<number> = breedsForType.find(b => b.id === task.petBreed) ?? {
        id: task.petBreed ?? 0,
        name: ''
    };

    return {
        id: task.petId ?? 0,
        name: task.petName ?? '—',
        petType,
        imageUrl: null,
        breed,
        hasMedicalConditions: task.petHasMedicalConditions ?? false,
        hasNegativeTags: task.petHasNegativePersonalities ?? false,
        hasMemberships: false,
        notesCount: 0
    };
};
